import * as React from 'react'
import { datalayerHandler } from '../../../utils/datalayer'
import { useInView } from '../../../utils/hooks/hooks/useInView'
import { Link } from '../../../utils/links'
import { maybeToMailPlusLink } from '../../../utils/mailplus'
import { downloadBlockClasses } from '../../../utils/style'
import { getClassName } from '../../../utils/utils'
import { InviewProps, SVGIconProps } from './blocksState'

export type DownloadsBlock = {
  index: number
  title?: React.ReactNode
  intro?: string
  items: DownloadBlockItem[]
  SVGIcon?: SVGIconProps
  inview?: InviewProps
}

export type DownloadBlockItem = {
  fileUrl: string
  title: string
  text?: string
}

export type DownloadBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  listClassName: string
  itemClassName: string
  linkClassName: string
  linkInnerClassName: string
  linkLabelClassName: string
  linkTextClassName: string
  linkIconClassName: string
  iconId: string
}>

export function DownloadBlockLayout(props: DownloadsBlock) {
  const { inview, index, intro, items, SVGIcon, title } = props
  const classes = downloadBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("DownloadBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')
  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(downloadBlockClasses, 'innerClassName', 'py-5')}>
        {(title || intro) && (
          <header className={getClassName(downloadBlockClasses, 'headerClassName', '')}>
            {title && (
              <h2
                className={getClassName(downloadBlockClasses, 'titleClassName', 'mb-3')}
                id={`${index}`}
              >
                {title}
              </h2>
            )}
            {intro && (
              <p className={getClassName(downloadBlockClasses, 'introClassName', '')}>
                {intro}
              </p>
            )}
          </header>
        )}

        {items && items.length > 0 && (
          <div className={getClassName(downloadBlockClasses, 'contentClassName', '')}>
            <ul
              className={getClassName(
                downloadBlockClasses,
                'listClassName',
                'list-unstyled mb-0 row'
              )}
            >
              {items.map(
                (item) =>
                  item.title && (
                    <li
                      key={`link-${index}-${item.title}`}
                      className={getClassName(
                        downloadBlockClasses,
                        'itemClassName',
                        'col-md-6'
                      )}
                    >
                      <Link
                        url={item.fileUrl}
                        title={item.title}
                        className={getClassName(
                          downloadBlockClasses,
                          'linkClassName',
                          'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                        )}
                        onClick={() =>
                          datalayerHandler('downloads', item.title, 'downloads', {
                            link: maybeToMailPlusLink(item.fileUrl)
                          })
                        }
                      >
                        <div className={getClassName(
                          downloadBlockClasses,
                          'linkInnerClassName',
                          ''
                        )}>
                          {item.title && (
                            <p
                              className={getClassName(
                                downloadBlockClasses,
                                'linkLabelClassName',
                                'm-0'
                              )}
                            >
                              {item.title}
                            </p>
                          )}
                          {item.text && (
                            <p
                              className={getClassName(
                                downloadBlockClasses,
                                'linkTextClassName',
                                'small m-0'
                              )}
                            >
                              {item.text}
                            </p>
                          )}
                        </div>
                        {SVGIcon && (
                          <svg
                            className={getClassName(
                              downloadBlockClasses,
                              'linkIconClassName',
                              ''
                            )}
                            aria-hidden="true"
                            width={SVGIcon.width ? SVGIcon.width : '24px'}
                            height={SVGIcon.height ? SVGIcon.height : '24px'}
                          >
                            <use
                              xlinkHref={`${
                                 getClassName(
                                  downloadBlockClasses,
                                  'iconId',
                                  '#icon--download'
                                  )
                              }`}
                            />
                          </svg>
                        )}
                      </Link>
                    </li>
                  )
              )}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}
